function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var WelcomeTemplate = require('./welcome.template');
var SaitoOverlay = require('./../../../../../lib/saito/ui/saito-overlay/saito-overlay');
var WelcomeOverlay = /*#__PURE__*/function () {
  function WelcomeOverlay(app, mod) {
    _classCallCheck(this, WelcomeOverlay);
    this.app = app;
    this.mod = mod;
    this.visible = false;
    this.overlay = new SaitoOverlay(app, mod, false, false, true);
  }
  return _createClass(WelcomeOverlay, [{
    key: "hide",
    value: function hide() {
      this.overlay.hide();
    }
  }, {
    key: "pullHudOverOverlay",
    value: function pullHudOverOverlay() {
      //
      // pull GAME HUD over overlay
      //
      var overlay_zindex = parseInt(this.overlay.zIndex);
      var hud = document.getElementById('game-hud2');
      if (hud) {
        hud.style.zIndex = overlay_zindex + 1;
      }
    }
  }, {
    key: "pushHudUnderOverlay",
    value: function pushHudUnderOverlay() {
      //
      // push GAME HUD under overlay
      //
      var overlay_zindex = parseInt(this.overlay.zIndex);
      var hud = document.getElementById('game-hud2');
      if (hud) {
        hud.style.zIndex = overlay_zindex - 2;
      }
    }
  }, {
    key: "renderCustom",
    value: function renderCustom() {
      var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var his_self = this.mod;
      if (document.querySelector('.winter')) {
        this.overlay.zIndex = his_self.winter_overlay.overlay.zIndex + 2;
      }
      this.overlay.show(WelcomeTemplate(''));
      this.pushHudUnderOverlay();
      this.overlay.pullOverlayToFront();
      if (obj.title) {
        document.querySelector('.welcome-title').innerHTML = obj.title;
      }
      if (obj.text) {
        document.querySelector('.welcome-text').innerHTML = obj.text;
      }
      if (obj.img) {
        document.querySelector('.welcome').style.backgroundImage = "url(".concat(obj.img, ")");
      }
      if (obj.card) {
        his_self.app.browser.addElementToSelector("<div class=\"welcome-card\">".concat(his_self.returnCardImage(obj.card), "<div>"), '.welcome');
      }
      if (obj.styles) {
        for (var z = 0; z < obj.styles.length; z++) {
          var s = obj.styles[z];
          document.querySelector('.welcome').style[s.key] = s.val;
        }
      }
      var overlay_zindex = parseInt(this.overlay.zIndex);
      document.querySelector('.welcome').style['zIndex'] = overlay_zindex;
      document.querySelector('.welcome').style['display'] = 'block';

      // this will clear any ACKNOWLEDGE
      this.attachEvents();
    }
  }, {
    key: "render",
    value: function render() {
      var faction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var his_self = this.mod;
      this.overlay.show(WelcomeTemplate(faction));
      this.pushHudUnderOverlay();
      if (faction === 'central') {
        document.querySelector('.welcome-title').innerHTML = "Central Powers";
        document.querySelector('.welcome-text').innerHTML = "You are playing as Germany and the Axis Powers this game.";
      }
      if (faction === 'allies') {
        document.querySelector('.welcome-title').innerHTML = "Allied Powers";
        document.querySelector('.welcome-text').innerHTML = "You are playing as Britain, France and the Allied Powers.";
      }
      this.attachEvents();
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var his_self = this.mod;
      $('.welcome').on('click', function () {
        // don't hide() AND removeOnClose
        //this.hide();
        if (document.querySelector('.option.acknowledge')) {
          document.querySelector('.option.acknowledge').click();
        }
      });
      $('.saito-overlay:has(> .welcome) + .saito-overlay-backdrop').on('click', function () {
        //this.hide();
        if (document.querySelector('.option.acknowledge')) {
          document.querySelector('.option.acknowledge').click();
        }
      });
    }
  }]);
}();
module.exports = WelcomeOverlay;